import { IoCalendarOutline, IoLocationOutline, IoMusicalNoteOutline } from "react-icons/io5";
import ColoredBackImage from "../../components/ColoredBackImage";
import Consts from "../../commons/Consts";
import moment from "moment";

const EventPageItem = ({ item, onClick }) => {
    const startsAt = moment(item.starts_at);
    const sortedTicketPrice = item.tickets.sort((a, b) => a.price - b.price);
    const priceRangeString =
        sortedTicketPrice.length
            ? (
                sortedTicketPrice[0].price !== sortedTicketPrice[sortedTicketPrice.length-1].price
                    ? `${sortedTicketPrice[0].price} - ${sortedTicketPrice[sortedTicketPrice.length-1].price}`
                    : sortedTicketPrice[0].price
            ) : 'GRATUIT';

    return (
        <div
            className={`bg-neutral-100 h-[480px] rounded-md overflow-hidden relative cursor-pointer`}
            onClick={() => onClick && onClick(item)}
        >
            <ColoredBackImage
                url={`${Consts.basefile}/events/covers/${item.cover}`}
                blackMask={0.4}
                expandOnHover={true}
            />
            <div className={`w-9 h-9 rounded-full bg-orange-500 absolute top-5 left-5 flex items-center justify-center z-[2]`}>
                <IoMusicalNoteOutline size={16} color="#fff" />
            </div>
            <div className={`absolute left-0 bottom-9 w-full px-10 z-[2]`}>
                <span className={`block text-base font-thin text-white`}>XOF {priceRangeString}</span>
                <h3 className={`block text-3xl font-bold text-white mt-0`}>{item.name}</h3>
                <div className={`flex items-center mt-2 gap-3 w-full flex-wrap`}>
                    <span className={`text-sm font-thin text-white flex shrink-0`}>
                        <IoCalendarOutline size={18} />
                        <span className={`ml-2`}>
                            {startsAt.format('DD MMM').toUpperCase().replace('.', '')}
                        </span>
                    </span>
                    <span className={`text-sm font-thin text-white flex`}>
                        <IoLocationOutline size={18} />
                        <span className={`ml-1 max-w-[140px] truncate`}>
                            {item.location_name}
                        </span>
                    </span>
                </div>
            </div>
        </div>
    );
};

export default EventPageItem;